import { api } from '../../../../api';
import { prepaySettings } from '../../../../config/api';
import { PrepaySettingsDTO } from '../model/types';

export const getPrepaySettingsRequest = (restaurantId: number) =>
  api.get<PrepaySettingsDTO>(prepaySettings(restaurantId));

export const updatePrepaySettingsRequest = (restaurantId: number, data: PrepaySettingsDTO) =>
  api.put<PrepaySettingsDTO>(prepaySettings(restaurantId), data);
